export const GET_MEDIA_FILE_SUCCESS = 'filePopUp/GET_MEDIA_FILE_SUCCESS'
export const GET_MEDIA_FILE_ERROR = 'filePopUp/GET_MEDIA_FILE_ERROR'

export const SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS = 'filePopUp/SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS'

export const LOAD_ACTION = 'filePopUp/LOAD_ACTION'
export const ERROR_ACTION = 'filePopUp/ERROR_ACTION'

export const filePopUpConstantsBlackList = [LOAD_ACTION, ERROR_ACTION]
